// src/components/parent-dashboard/components/Notification.js
import React from "react";
import { AlertCircle, CheckCircle, X } from "lucide-react";

/**
 * Toast notification component
 * Displays success, error, or info messages
 */
const Notification = ({ notification, setNotification }) => {
    if (!notification.show) return null;

    return (
        <div className={`fixed bottom-4 right-4 max-w-md px-4 py-3 rounded-lg shadow-lg flex items-center ${
            notification.type === "success" ? "bg-green-100 text-green-800 border-l-4 border-green-500" :
                notification.type === "error" ? "bg-red-100 text-red-800 border-l-4 border-red-500" :
                    "bg-blue-100 text-blue-800 border-l-4 border-blue-500"
        }`}>
            {notification.type === "success" ?
                <CheckCircle className="w-5 h-5 mr-3"/> :
                <AlertCircle className="w-5 h-5 mr-3"/>
            }
            <span>{notification.message}</span>
            <button
                onClick={() => setNotification({show: false, message: "", type: ""})}
                className="ml-4 text-gray-500 hover:text-gray-700"
            >
                <X className="w-4 h-4"/>
            </button>
        </div>
    );
};

export default Notification;